module.exports = __webpack_public_path__ + "img/otprostogo-mob.69c47344.png";